import {
  Button,
  createTableColumn,
  TableColumnDefinition,
  Menu,
  MenuTrigger,
  MenuItem,
  MenuList,
  MenuPopover,
  Checkbox,
} from "@fluentui/react-components";
import i18n from "i18next";
import React, { useEffect, useState } from "react";
import {
  DeleteRegular,
  EditRegular,
  LockClosedRegular,
  MoreVerticalRegular,
  PeopleTeamRegular,
} from "@fluentui/react-icons";
import { IUserBedarfPosition } from "../../../Models/IUserBedarfPosition";

interface IRequestsColumnsProps {
  checkedItemsGuid(item: IUserBedarfPosition[]): void;
  resetChecked: boolean;
  selectedTab: string;
  allItems: IUserBedarfPosition[];
  hoveredItem: string | undefined;
}

export function RequestsColumns(props: IRequestsColumnsProps) {
  const [checkedItems, setCheckedItems] = useState<IUserBedarfPosition[]>([]);

  useEffect(() => {
    setCheckedItems([]);
  }, [props.resetChecked]);
  const columns: TableColumnDefinition<IUserBedarfPosition>[] = [];
  if (props.selectedTab == "open") {
    columns.push(
      createTableColumn<IUserBedarfPosition>({
        columnId: "checkboxId",
        renderHeaderCell: () => {
          return (
            <Checkbox
              checked={
                checkedItems.length != 0 &&
                props.allItems.length == checkedItems.length
              }
              onChange={(ev, data) => {
                if (data.checked == true) {
                  setCheckedItems(props.allItems);

                  props.checkedItemsGuid(props.allItems);
                } else {
                  setCheckedItems([]);
                  props.checkedItemsGuid([]);
                }
              }}
            ></Checkbox>
          );
        },
        renderCell: (item) => {
          return (
            <div>
              {(props.hoveredItem == item.userBedarfGuid ||
                checkedItems.includes(item)) && (
                <Checkbox
                  checked={checkedItems.includes(item)}
                  onChange={(ev, data) => {
                    var newList: IUserBedarfPosition[] = [];
                    const currentCheckedItems = [...checkedItems];
                    if (data.checked) {
                      if (!currentCheckedItems.includes(item)) {
                        currentCheckedItems.push(item);
                        newList = currentCheckedItems;
                      }
                    } else {
                      newList = currentCheckedItems.filter(
                        (x: IUserBedarfPosition) =>
                          x.userBedarfGuid != item.userBedarfGuid,
                      );
                    }
                    setCheckedItems(newList);
                    props.checkedItemsGuid(newList);
                  }}
                  shape="circular"
                ></Checkbox>
              )}
            </div>
          );
        },
      }),
    );
  }

  columns.push(
    createTableColumn<IUserBedarfPosition>({
      columnId: "artikelId",
      compare: (a, b) => {
        if (a.artikelId && b.artikelId) {
          return a.artikelId.localeCompare(b.artikelId);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("artikelId");
      },
      renderCell: (item) => {
        return <div>{item.artikelId ? item.artikelId : item.produktId}</div>;
      },
    }),
    createTableColumn<IUserBedarfPosition>({
      columnId: i18n.language.includes("de") ? "bennenungDE" : "benennungEN",
      compare: (a, b) => {
        if (a.benennungDE && b.benennungDE) {
          return a.benennungDE.localeCompare(b.benennungDE);
        } else if (a.benennungEN && b.benennungEN) {
          return a.benennungEN.localeCompare(b.benennungEN);
        }
        return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("benennung");
      },
      renderCell: (item) => {
        return (
          <div>
            {i18n.language.includes("de") ? item.benennungDE : item.benennungEN}
          </div>
        );
      },
    }),
    createTableColumn<IUserBedarfPosition>({
      columnId: "menge",
      compare: (a, b) => {
        if (a.menge && b.menge) {
          return a.menge - b.menge;
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("menge");
      },
      renderCell: (item) => {
        return <div>{item.menge}</div>;
      },
    }),
    createTableColumn<IUserBedarfPosition>({
      columnId: "createdBy.email",
      compare: (a, b) => {
        if (a.createdBy.email && b.createdBy.email) {
          return a.createdBy.email.localeCompare(b.createdBy.email);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("createdBy");
      },
      renderCell: (item) => {
        return <div>{item.createdBy.email}</div>;
      },
    }),
    createTableColumn<IUserBedarfPosition>({
      columnId: "gesendetAm",
      compare: (a, b) => {
        if (a.gesendetAm && b.gesendetAm) {
          return a.gesendetAm.localeCompare(b.gesendetAm);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("sentOn");
      },
      renderCell: (item) => {
        if (item.gesendetAm) {
          return <div>{new Date(item.gesendetAm).toLocaleDateString()}</div>;
        }
      },
    }),
  );
  if (props.selectedTab == "finished") {
    columns.push(
      createTableColumn<IUserBedarfPosition>({
        columnId: "bearbeitetVon.email",
        compare: (a, b) => {
          if (a.bearbeitetVon.email && b.bearbeitetVon.email) {
            return a.bearbeitetVon.email.localeCompare(b.bearbeitetVon.email);
          } else return 0;
        },
        renderHeaderCell: () => {
          return i18n.t<string>("finishedBy");
        },
        renderCell: (item) => {
          if (item.bearbeitetVon && item.bearbeitetVon.email) {
            return <div>{item.bearbeitetVon.email}</div>;
          }
        },
      }),
      createTableColumn<IUserBedarfPosition>({
        columnId: "bearbeitetAm",
        compare: (a, b) => {
          if (a.bearbeitetAm && b.bearbeitetAm) {
            return a.bearbeitetAm.localeCompare(b.bearbeitetAm);
          } else return 0;
        },
        renderHeaderCell: () => {
          return i18n.t<string>("finishedOn");
        },
        renderCell: (item) => {
          if (item.bearbeitetAm) {
            return (
              <div>{new Date(item.bearbeitetAm).toLocaleDateString()}</div>
            );
          }
        },
      }),
      createTableColumn<IUserBedarfPosition>({
        columnId: "model?.offerId",
        renderHeaderCell: () => {
          return i18n.t<string>("offerId");
        },
        renderCell: (item) => {
          return <div>{item.model?.offerId}</div>;
        },
      }),
    );
  }

  return columns;
}
